import React, { useReducer } from "react";
import Btn from "../../Components/Btn/Btn";
import "./Contact.css";

const Contact = () => {
  const initialState = { name: "", number: "", message: "" };

  const reducer = (state, action) => {
    switch (action.type) {
      case "SET_FIELD":
        return { ...state, [action.field]: action.value };
      case "RESET":
        return initialState;
      default:
        return state;
    }
  };

  const [form, dispatch] = useReducer(reducer, initialState);

  const handleChange = (e) => {
    dispatch({
      type: "SET_FIELD",
      field: e.target.name,
      value: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, number, message } = form;

    if (name.length < 4 || number.length !== 10 || message.length < 10) {
      alert("Completează toate câmpurile corect.");
      return;
    }

    const whatsappLink = `https://wa.me/40765288783?text=Nume:%20${encodeURIComponent(
      name
    )}%0ANumăr:%20${encodeURIComponent(number)}%0AMesaj:%20${encodeURIComponent(
      message
    )}`;

    window.open(whatsappLink, "_blank");

    dispatch({ type: "RESET" });
  };

  return (
    <section className="contact" id="contact">
      <div className="sub-title">
        <h2 className="text-2">
          <span className="highlight">Contact</span>
        </h2>
        {/* <p className="p-1">
          Solicită o sesiune de consultanță 1:1 și primește îndrumări
          personalizate pentru a face cele mai bune alegeri pentru afacerea ta.
        </p> */}
      </div>
      <div className="contact-form">
        <img
          className="contact-img"
          src="https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726764371/RealCode/contact/Illustration_4_j1z6lm.svg"
          alt="contact img"
        />
        <form className="form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nume</label>
            <input
              type="text"
              name="name"
              placeholder="Numele tău"
              value={form.name}
              onChange={handleChange}
              maxLength={50}
            />
          </div>

          <div className="form-group">
            <label htmlFor="number">Număr de telefon</label>
            <input
              name="number"
              type="text"
              placeholder="+40"
              value={form.number}
              onChange={handleChange}
              maxLength={10}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Mesaj</label>
            <textarea
              name="message"
              rows="10"
              placeholder="Descrie afacerea ta, obiectivele sau provocările cu care te confrunți, iar noi te vom ajuta să găsești cele mai bune soluții."
              value={form.message}
              onChange={handleChange}
              minLength={20}
            ></textarea>
          </div>

          <Btn variant={"dark"}>Trimite mesaj</Btn>
        </form>
      </div>
    </section>
  );
};

export default Contact;
